import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization owner or team admin, you can create teams to manage access to sets of packages governed by your organization.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Team names cannot be changed. To "rename" a team, you must delete the team and recreate it.`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-teams-tab'].text}</>
        <>{shared['organization-teams-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the "Name" and "Description" fields, type a team name and helpful description. Team names must be lower case and cannot contain spaces or punctuation.`}</p>
        <Screenshot src="/organizations/managing-teams/team-name-description.png" alt="Screenshot of team name and description" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Make it so`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-creation-confirmation.png" alt="Screenshot of the team creation confirmation button" mdxType="Screenshot" />
      </li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` New teams do not have members or package access by default. Once you create a team, add packages and members from the "Teams" tab.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      